import { render } from "./TopScene.vue?vue&type=template&id=56f628a2&scoped=true"
import script from "./TopScene.vue?vue&type=script&lang=js"
export * from "./TopScene.vue?vue&type=script&lang=js"

import "./TopScene.vue?vue&type=style&index=0&id=56f628a2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f628a2"]])

export default __exports__